module.exports = __webpack_public_path__ + "static/media/marker_client.3e64abd6.svg";